export enum LayoutHeaderEnum {
    AuctionId = 'auctionId',
}
